import {AbstractControl} from '@angular/forms';
import { environment } from 'src/environments/environment';
import Cookies from "js-cookie";
import { CriteriaType, DevicePulseStatusEnum, HandleJsonUploadParams, SuccessCriteria, TicketColumnsEnum } from './models';
import moment from 'moment';

export function handleError(e: any): string {
  return (e && e.error && e.error.message) || 'Something went wrong. Please try again.';
}

export function timeDurationToReadableForm(time) {
  // let startDate = new Date(startTime);
  // let endDate = new Date(endTime);
  let diffMs = (time * 60 * 1000); // milliseconds between now & Christmas
  let diffDays = Math.floor(diffMs / 86400000); // days
  let diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
  let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
  if (diffDays === 0) {
    if (diffHrs === 0) {
      return (diffMins + ' minutes');
    }
    return (diffHrs + ' hours, ' + diffMins + ' minutes');
  }
  return (diffDays + ' days, ' + diffHrs + ' hours, ' + diffMins + ' minutes');
}

export function isEmpty(obj) {
  for (const prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}

export function newDateFromGiven(date) {
  const dashSplit = date.toString().split('-')
  const spaceSplit = dashSplit[2].toString().split(' ')
  const colonSplit = spaceSplit[1].toString().split(':')
  return new Date(dashSplit[0], dashSplit[1] - 1, spaceSplit[0], colonSplit[0], colonSplit[1], colonSplit[2])
}

export function timeSince(date) {
  if (!date) {
    return;
  }
  let sinceDate = newDateFromGiven(date).getTime()
  let seconds = Math.floor((new Date().getTime() - sinceDate) / 1000);
  let sinceTime = null
  let min, hours, days
  if (seconds < 60) {
    return sinceTime = "few seconds ago"
  } else if (seconds < 3600) {
    min = Math.floor(seconds / 60)
    return sinceTime = min + " minutes ago"
  } else if (seconds < 86400) {
    hours = Math.floor(seconds / 3600)
    return sinceTime = hours + " hours ago"
  } else if (seconds > 86400) {
    days = Math.floor(seconds / 86400)
    return sinceTime = days + " days ago"
  } else {
    return date
  }
}

export function convert24Hr(time) {
  if (time.includes('AM') || time.includes('PM')) {
    const convertTime = time.split(/:|\s/)

    var hours = parseInt(convertTime[0], 10)
    var min = parseInt(convertTime[1], 10)
    var sec = parseInt(convertTime[2], 10)
    var period = convertTime[3].toUpperCase()

    if (period === 'PM' && hours < 12) {
      hours += 12;
      console.log(hours)
    } else if (period === 'AM' && hours === 12) {
      hours = 0;
    }

    var time24hr = (hours < 10 ? '0' : '') + hours + ':' + (min < 10 ? '0' : '') + min + ':' + (sec < 10 ? '0' : '') + sec;
    return time24hr;
  }
}

export function numericValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const isValid = /^\d+$/.test(control.value);
  return isValid ? null : {'notNumeric': true};
}

export function isValidBatchNumber(control: AbstractControl): { [key: string]: boolean } | null{
  const hasLetter = /[a-zA-Z]/.test(control.value); // Check for at least one letter
  const hasNumber = /\d/.test(control.value);       // Check for at least one digit
  const isAlphanumeric = /^[a-zA-Z0-9_-]+$/.test(control.value); // Only alphanumeric characters
  const hasUnderscoreOrHyphen = /[_-]/.test(control.value);
  const isValid = hasLetter && hasNumber && isAlphanumeric && hasUnderscoreOrHyphen;
  return isValid ?  null : {'notAlphaNumeric': true};
};

export function numberToWords(num) {
  const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

  if (num < 10) return ones[num];
  if (num < 20) return teens[num - 10];
  if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 === 0 ? '' : ' ' + ones[num % 10]);
  if (num < 1000) return ones[Math.floor(num / 100)] + ' hundred' + (num % 100 === 0 ? '' : ' ' + numberToWords(num % 100));
}

export const formatSuccessCriteria = (criteria: string): string => {
  return criteria
      .replace(/_/g, ' ')
      .split(' ') 
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' '); 
};

//device parameter configurations - default value validations

export const isCharValid=(value) =>{
  return /^.$/.test(value); // any single character
 // return /^[a-zA-Z]$/.test(value);  //any single alphabet
}
export const isNumeric=(value)=> {
  return !isNaN(value) && !isNaN(parseFloat(value));
}
export const isStrictInteger=(value)=> {
  if(isNaN(value)){
    return false; // Return false for invalid numbers
  }
  const num = parseFloat(value);
  return Number.isInteger(num) && value.indexOf('.') === -1;
}

export const toBrowserTimeZone = (value) => {

    const timeZone = moment.tz.guess();
    // console.log("timeZone: ",timeZone)

    const ist = moment.tz(value, 'UTC');
    // console.log("ist: ",ist)

    ist.tz(timeZone);
    // console.log("ist: ",ist)
    // console.log("toBrowserTimeZone: ",ist.format('YYYY-MM-DD HH:mm:ss'))

    return ist.format('YYYY-MM-DD HH:mm:ss');
}

export const formatLargeNumber = (num) => {
  let scale = "";
  if (num >= 1e9) {
    scale = "Billions";
    return { value: (num / 1e9).toFixed(3), scale }; // Billions
  } else if (num >= 1e6) {
    scale = "Millions";
    return { value: (num / 1e6).toFixed(3), scale }; // Millions
  } else if (num >= 1e3) {
    scale = "Thousands";
    return { value: (num / 1e3).toFixed(3), scale }; //Thousands
  }
  return { value: num.toString(), scale: "" }; // Less than 1000, return as-is
};

export const azureService = () =>{
  const planId = Cookies.get('PLANID')
  
    const isAzureFreePackage = () =>{
      return environment.azurepackageFreeId == planId
    }
  
    const isAzureBasicPackage = () =>{
      return environment.azurepackageBasicId == planId
    }
  
    const isAzurePremiumPackage = () =>{
      return environment.azurepackagePremiumId == planId
    }

  return { isAzureFreePackage, isAzureBasicPackage, isAzurePremiumPackage };
}

export const isTestAutomationUser=(): boolean =>{
  const role = parseInt(Cookies.get('ROLE'), 10);
  return role >= 10 && role < 100;
}

export function hasPermision(path) {
  const { isAzureFreePackage, isAzureBasicPackage, isAzurePremiumPackage } = azureService();

  if (isAzureFreePackage() && ['TestCases', 'RootCauseConfig', 'ChatbotConfig', 'ChatHistory','RootCauseAnalysis','HumanoidNotificationSystem','Automl','problemType', 'DeviceFailure'].includes(path)) {
    return false;
  }
  if (isAzureBasicPackage() && ['ChatbotConfig', 'ChatHistory','HumanoidNotificationSystem','RootCauseConfig','RootCauseAnalysis','Automl','problemType', 'DeviceFailure'].includes(path)) {
    return false;
  }
  if (isAzurePremiumPackage() && ['problemType'].includes(path)) {
    return false;
  }
  return true;
}

export const convertToMinutes = (value: number, period: string): number => {
  switch (period.toLowerCase()) {
    case "days":
      return value * 24 * 60;
    case "weeks":
      return value * 7 * 24 * 60;
    case "months":
      return value * 30 * 24 * 60;
    case "hours":
      return value * 60;
    case "minutes":
    default:
      return value;
  }
};

export enum userActionType{
  USER_ADD = 'userAdd',
  ALERT_EDIT = 'alert-edit',
  ALERT_ADD = 'alert-add'
}

export enum status{
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export const convertToPeriod = (minutes, period) => ({
  DAYS: minutes / 1440,
  WEEKS: minutes / 10080,
  MONTHS: minutes / 43200,
  HOURS: minutes / 60,
  MINUTES: minutes,
}[period.toUpperCase()] || minutes);

export const periodMap = { 
  "Hours": "HOURS", 
  "Days": "DAYS", 
  "Minutes": "MINUTES",
  "Weeks":"WEEKS",
  "MONTHS":"Months"
};

export const capitalizeFirstLetter = (word) =>{
  if (!word) return ""; // Handle empty strings
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

export const  capitalizeWords = (sentence) => {
  if (!sentence) return sentence; // Handle empty strings
  return sentence
    .split(' ')
    .map(word => capitalizeFirstLetter(word))
    .join(' ');
}

export const clickBack = (history: any, path: any) => {
  history.push(path);
};

export const getUserRoleName = (userRoleId: number, userRoles: { id: number; name: string }[]): string => {
  const role = userRoles.find(role => role.id === Number(userRoleId));
  return role ? role.name : 'N/A';
};

export const getPrefixes = (batchNumbers) => {
  const prefixSet = new Set();

  batchNumbers.forEach((res) => {
      if (res.includes('_') || res.includes('-')) {
          prefixSet.add(res.split(/[_-]/)[0]);
      }
  });

  return Array.from(prefixSet);
};

export const toCamelCaseWithSpaces = (str) => {
  return str
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const isPlanId = (): boolean => {
  const planId = Cookies.get('PLANID');
  return planId !== null && planId !== 'undefined';
}

export const getColor = (status) => {
  if(status === 'To Do' || status === 'Failure Identified'){
    return '#868DAA'
  } else if(status === 'In Progress' || status === 'Under troubleshooting'){
    return '#005B96'
  } else if(status === 'On Hold' || status === 'Pending'){
    return '#DDA01E'
  } else if(status === 'Reopened' || status === 'Recurring failure'){
    return '#FF4343'
  } else if(status === 'Done' || status === 'Resolved'){
    return '#00B1A5'
  }
}

export const getBackgroundColor = (status) => {
  if(status === 'To Do' || status === 'Failure Identified'){
    return 'rgba(134, 141, 170, 0.05)'
  } else if(status === 'In Progress' || status === 'Under troubleshooting'){
    return 'rgba(0, 91, 150, 0.05)'
  } else if(status === 'On Hold' || status === 'Pending'){
    return 'rgba(221, 160, 30, 0.05)'
  } else if(status === 'Reopened' || status === 'Recurring failure'){
    return 'rgba(255, 67, 67, 0.05)'
  } else if(status === 'Done' || status === 'Resolved'){
    return 'rgba(0, 177, 165, 0.05)'
  }
}

export const devicePulseStatus = [
  { id: 1, status: DevicePulseStatusEnum.FAILURE_IDENTIFIED },
  { id: 2, status: DevicePulseStatusEnum.UNDER_TROUBLESHOOTING },
  { id: 3, status: DevicePulseStatusEnum.RECURRING_FAILURE },
  { id: 4, status: DevicePulseStatusEnum.RESOLVED }
];

export const ticketColumns = [
  { id: 1, column: TicketColumnsEnum.TICKET_ID },
  { id: 2, column: TicketColumnsEnum.TICKET_SUMMARY },
  { id: 3, column: TicketColumnsEnum.TICKET_DESCRIPTION },
  { id: 4, column: TicketColumnsEnum.TICKET_STATUS },
  { id: 5, column: TicketColumnsEnum.TICKET_PRIORITY },
  { id: 6, column: TicketColumnsEnum.ASSIGNED_TO },
  { id: 7, column: TicketColumnsEnum.REPORTER }
]

export const formatSriLankanDateTime = (dateString) => {
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'Asia/Colombo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  };

  const formatter = new Intl.DateTimeFormat('en-US', options);
  const parts = formatter.formatToParts(date);

  const year = parts.find(part => part.type === 'year').value;
  const month = parts.find(part => part.type === 'month').value;
  const day = parts.find(part => part.type === 'day').value;
  const hour = parts.find(part => part.type === 'hour').value;
  const minute = parts.find(part => part.type === 'minute').value;
  const second = parts.find(part => part.type === 'second').value;

  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
};

export const handleDevicePulseClicked = () => {
  const event = new CustomEvent('devicePulseClicked');
    window.dispatchEvent(event);
}

export const criteriaTypeMap: Record<SuccessCriteria, CriteriaType> = {
  [SuccessCriteria.NO_OF_DATA]: CriteriaType.SPECIAL,
  [SuccessCriteria.GREATER_THAN]: CriteriaType.SINGLE_VALUE,
  [SuccessCriteria.GREATER_THAN_OR_EQUAL_TO]: CriteriaType.SINGLE_VALUE,
  [SuccessCriteria.LESS_THAN]: CriteriaType.SINGLE_VALUE,
  [SuccessCriteria.LESS_THAN_OR_EQUAL_TO]: CriteriaType.SINGLE_VALUE,
  [SuccessCriteria.IS_EQUAL_TO]: CriteriaType.SINGLE_VALUE,
  [SuccessCriteria.IS_NOT_EQUAL_TO]: CriteriaType.SINGLE_VALUE,
  [SuccessCriteria.IS_BETWEEN]: CriteriaType.RANGE_VALUE,
  [SuccessCriteria.IS_NOT_BETWEEN]: CriteriaType.RANGE_VALUE,
  [SuccessCriteria.AVERAGE]: CriteriaType.SPECIAL,
  [SuccessCriteria.IS_INCREASING]: CriteriaType.RANGE_VALUE,
  [SuccessCriteria.IS_DECREASING]: CriteriaType.RANGE_VALUE,
  [SuccessCriteria.IS_VALUE_PRESENCE]: CriteriaType.SINGLE_VALUE
};

export const handleJsonUploadHelper = ({
  event,
  jsonFiles,
  filteredApiConfigDetails = [], // default to empty array
  setIsAddJson,
  setIsToasterOpen,
  setReqSuccess,
  setToasterMessage,
  setselectedJsonFile,
}: HandleJsonUploadParams) => {
  setIsAddJson(false);
  const input = event.target;

  if (!input.files || input.files.length === 0) return;

  const file = input.files[0];

  const showError = (message: string) => {
    setIsToasterOpen(true);
    setReqSuccess(false);
    setToasterMessage(message);
    setselectedJsonFile(null);
    input.value = "";
    setTimeout(() => setIsToasterOpen(false), 2500);
  };

  const isDuplicate = jsonFiles.some(
    (json) => json.name.trim().toLowerCase() === file.name.trim().toLowerCase()
  );

  const isExist = filteredApiConfigDetails.some(
    ([filename]) => filename.toLowerCase() === file.name.trim().toLowerCase()
  );

  if (isDuplicate || isExist) {
    return showError("This file has already been attached.");
  }

  const reader = new FileReader();

  reader.onload = () => {
    const result = reader.result;
    if (typeof result !== "string") {
      return showError("Unexpected file format.");
    }

    try {
      const cleanResult = result.replace(/^\uFEFF/, "");
      const fileContent = JSON.parse(cleanResult);

      if (!fileContent.openapi) {
        return showError("This file is not in OpenAPI format.");
      }

      setselectedJsonFile(file);
    } catch (err) {
      console.error("JSON parse error:", err);
      showError("Invalid JSON file format.");
    }
  };

  reader.onerror = () => showError("Error reading file.");
  reader.readAsText(file);
};

const getMappedStatus = (jiraStatus, statusMap) => {
  if (!statusMap) return jiraStatus;
  
  for (const [deviceStatus, mappedJiraStatus] of Object.entries(statusMap)) {
    if (mappedJiraStatus === jiraStatus) {
      return deviceStatus;
    }
  }
  
  return jiraStatus;
}

export const getStatusColor = (jiraStatus, statusMap) => {
  const status = getMappedStatus(jiraStatus, statusMap);
  
  switch(status) {
    case 'Failure Identified':
      return '#868DAA';
    case 'Under troubleshooting':
      return '#005B96';
    case 'Recurring failure':
      return '#FF4343';
    case 'Resolved':
      return '#00B1A5';
    default:
      return '#000000';
  }
}

export const getStatusBackgroundColor = (jiraStatus, statusMap) => {
  const status = getMappedStatus(jiraStatus, statusMap);
  
  switch(status) {
    case 'Failure Identified':
      return 'rgba(134, 141, 170, 0.05)';
    case 'Under troubleshooting':
      return 'rgba(0, 91, 150, 0.05)';
    case 'Recurring failure':
      return 'rgba(255, 67, 67, 0.05)';
    case 'Resolved':
      return 'rgba(0, 177, 165, 0.05)';
    default:
      return 'rgba(0, 0, 0, 0.05)';
  }
}

export const optionConfig = [
  {
    value: "I misunderstood your question",
    needsInput: false
  },
  {
    value: "I needed more technical details",
    needsInput: false
  },
  {
    value: "The suggested solution didn't work",
    needsInput: true,
    placeholder: "Please provide the solution that successfully resolved that issue..."
  },
  {
    value: "The identified root cause was incorrect",
    needsInput: true,
    placeholder: "Please provide the confirmed root cause of the device failure..."
  },
  {
    value: "Other (please specify)",
    needsInput: true,
    placeholder: "Please specify your reason here..."
  }
];

export const generateMonthOptions = (createdDateStr) => {
  const options = [];
  const createdDate = new Date(createdDateStr);
  const now = new Date();
  
  const currentMonthStart = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
  
  let periodStart = new Date(Date.UTC(
    createdDate.getUTCFullYear(),
    createdDate.getUTCMonth(),
    1
  ));
  
  while (periodStart <= currentMonthStart) {
    const isCreatedMonth = 
      periodStart.getUTCFullYear() === createdDate.getUTCFullYear() && 
      periodStart.getUTCMonth() === createdDate.getUTCMonth();
    
    const startDate = isCreatedMonth
      ? new Date(createdDate)
      : new Date(Date.UTC(
          periodStart.getUTCFullYear(),
          periodStart.getUTCMonth(),
          1
        ));
    
    const endDate = new Date(Date.UTC(
      periodStart.getUTCFullYear(),
      periodStart.getUTCMonth() + 1,
      0,
      23, 59, 59, 999
    ));
    
    const displayText = `${formatUTCDate(startDate)} - ${formatUTCDate(endDate)}`;
    
    options.push({
      displayText,
      value: `${startDate.toISOString()}|${endDate.toISOString()}`
    });
    
    periodStart = new Date(Date.UTC(
      periodStart.getUTCFullYear(),
      periodStart.getUTCMonth() + 1,
      1
    ));
  }
  
  return options.reverse();
};

export const returnBrowserTimeZone = (value) => {

  const timeZone = moment.tz.guess();
  const ist = moment.tz(value, 'Asia/Colombo');

  ist.tz(timeZone);
  // console.log("toBrowserTimeZone: ",ist.format('YYYY-MM-DD HH:mm:ss'))

  return ist.format('YYYY-MM-DD HH:mm:ss');
}

function formatUTCDate(date) {
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
}

export function pad(num: number): string {
  return num.toString().padStart(2, '0');
}

// Helper: normalize, compare and filter semantic-like versions
export function normalizeVersionStr(v) {
  if (v === undefined || v === null) return "";
  // remove surrounding quotes and whitespace
  return String(v).trim().replace(/^\s*"|"\s*$|^\s*'|'\s*$/g, "");
}
function parseVersionParts(v) {
  return normalizeVersionStr(v)
    .split('.')
    .map((p) => {
      const n = parseInt(p, 10);
      return isNaN(n) ? p : n;
    });
}
export function isVersionGreater(a, b) {
  if (!a || !b) return false;
  const pa = parseVersionParts(a);
  const pb = parseVersionParts(b);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const va = pa[i] === undefined ? 0 : pa[i];
    const vb = pb[i] === undefined ? 0 : pb[i];
    if (typeof va === 'number' && typeof vb === 'number') {
      if (va > vb) return true;
      if (va < vb) return false;
    } else {
      const sa = String(va);
      const sb = String(vb);
      if (sa > sb) return true;
      if (sa < sb) return false;
    }
  }
  return false; // equal
}